// extracted by mini-css-extract-plugin
export var image = "dd_dj";